"use client";

import { c as _c } from "react/compiler-runtime";
import type { Route } from "next";
import { type LinkProps as NextLinkProps } from "next/link";
import { Link } from "@repo/components/atoms";
import { cn } from "@repo/lib";
export type LinkProps<T = string> = {
  active: boolean;
  className?: string;
  title: string;
} & NextLinkProps<T>;
export function RefineByListItem(t0) {
  const $ = _c(9);
  const {
    active,
    href,
    title
  } = t0;
  let t1;
  if ($[0] !== active) {
    t1 = cn("w-full", {
      "font-bold": active
    });
    $[0] = active;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = href as Route;
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== title) {
    t3 = <Link className={t1} href={t2} prefetch={false}>{title}</Link>;
    $[2] = t1;
    $[3] = t2;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== title) {
    t4 = <li className="mt-2 flex text-sm" key={title}>{t3}</li>;
    $[6] = t3;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}